package com.artvending.warden

import kotlinx.coroutines.delay

interface HttpClient {
	suspend fun sendGetRequest(url: String, cookies: Map<String, String> = emptyMap<String, String>()): String?
	
	suspend fun sendPostRequest(url: String, vararg params: Pair<String, Any?>): String?
	
	
	private suspend fun multiSendRequest(requestBlock: suspend () -> String?) = multiTry(commonSettings.MULTI_REQUEST_COUNT, commonSettings.MULTI_REQUEST_PAUSE) { requestBlock() }
	
	
	suspend fun multiSendGetRequest(url: String, cookies: Map<String, String> = emptyMap<String, String>()) = multiSendRequest { httpClient.sendGetRequest(url) }
	
	
	suspend fun multiSendPostRequest(url: String, vararg params: Pair<String, Any?>) = multiSendRequest { httpClient.sendPostRequest(url, *params) }
}